<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UpLevelAvgStat',
  props: {
    title: {
      type: String,
      default: '通关次数分布'
    },
    typ: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      chart: {},
      option: {},
      lvMap: [
        '1-2',
        '2-3',
        '3-5',
        '5-10',
        '10-20',
        '20-30',
        '30-60',
        '60-90',
        '90-120',
        '120+'
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: [
          '#FF69B4', '#00BFFF', '#FF7F50', '#BA55D3', '#FF0000',
          '#008000', '#4169E1', '#2F4F4F', '#BA55D3', '#6A5ACD'
        ],
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: this.lvMap,
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [

        ]
      }
    },
    refresh(data) {
      const time = []
      const upLevelData = {}

      for (let i = 1; i <= 10; i++) {
        if (this.typ === 1) {
          upLevelData['lv' + i] = []
        } else {
          upLevelData['lv' + i + 'Avg'] = []
        }
      }

      for (const i in data) {
        const val = data[i]
        time.push(dateStrTodate(data[i].date))
        for (const k in val) {
          if (upLevelData[k] !== undefined) {
            upLevelData[k].push(val[k])
          }
        }
      }
      let index = 0
      for (const i in upLevelData) {
        const temp = {
          name: this.lvMap[index],
          data: upLevelData[i],
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'right', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          }
        }
        index++
        this.option.series.push(temp)
      }
      this.option.title.text = this.title
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
